export default __webpack_public_path__ + "static/media/icon_policy_overview_step1-4.1a4aba6e.svg";